import { render } from "./PaymentLinkPage.vue?vue&type=template&id=86ad2e8a&scoped=true"
import script from "./PaymentLinkPage.vue?vue&type=script&lang=js"
export * from "./PaymentLinkPage.vue?vue&type=script&lang=js"

import "./PaymentLinkPage.vue?vue&type=style&index=0&id=86ad2e8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86ad2e8a"]])

export default __exports__